import { Injectable } from '@angular/core';

@Injectable()
export class FileTypeService {

  isMarkdown(file: any): boolean {
    const type = (file.fileType || '').toLowerCase();
    const name = (file.fileName || '').toLowerCase();
    return type.startsWith('text/markdown') || type.startsWith('text/x-markdown')
      || name.endsWith('.md') || name.endsWith('.markdown');
  }

  isHtml(file: any): boolean {
    return (file.fileType || '').toLowerCase().startsWith('text/html');
  }

  isImage(file: any): boolean {
    const type = (file.fileType || '').toLowerCase();
    const name = (file.fileName || '').toLowerCase();
    return type.startsWith('image/')
      || /\.(gif|jpg|jpeg|png|webp|avif|tiff|bmp|svg)$/.test(name);
  }

  isVideo(file: any): boolean {
    const type = (file.fileType || '').toLowerCase();
    const name = (file.fileName || '').toLowerCase();
    return type.startsWith('video/')
      || /\.(mp4|webm|ogg|mov|avi|m4v|mpeg)$/.test(name);
  }

  isAudio(file: any): boolean {
    const type = (file.fileType || '').toLowerCase();
    const name = (file.fileName || '').toLowerCase();
    return type.startsWith('audio/')
      || /\.(mp3|wav|m4a|aac|flac|opus|weba)$/.test(name);
  }

  isRenderable(file: any): boolean {
    // HTML intentionally excluded: rendering untrusted uploaded HTML poses XSS risk
    return this.isMarkdown(file) || this.isImage(file) || this.isVideo(file) || this.isAudio(file);
  }

  formatFileSize(bytes: number): string {
    if (!bytes || bytes === 0) { return '0 B'; }
    if (bytes < 1024) { return bytes + ' B'; }
    if (bytes < 1048576) { return (bytes / 1024).toFixed(1) + ' KB'; }
    return (bytes / 1048576).toFixed(1) + ' MB';
  }
}
